module.exports = __webpack_public_path__ + "img/logo.75dd4a49.png";